import { useSelector,useDispatch } from 'react-redux'
import { AspectRatio, Grid } from '@mantine/core';
import UserShowDoc from './helper/UserShowDoc';

import UserShowSignDocStapel from './helper/UserShowSignDocStapel';
import { setdisplaywidth } from '../slice/mainslice';
import intl from 'react-intl-universal';



/**
 * Generates the User Video View component which displays the user's video view along with additional document views if available.
 * 
 * 
 * @cmslink: {string} - state.user.cmslink - The cuurrent CMS link.
 * @meuser: {Object} - state.user.meuser - The current user.
 * @signprozess: {boolean} - state.user.signprozess - SignView prozess.
 * @showdoc: {Object} - state.user.showmeetingdocs - Objekt der Dokumente im Meeting.
 * @showsigndoc: {Object} - state.user.showsignmeetingdocs - Objekt des Dokumentes to Sign.
 * @displaytyp: number - state.user.displaytyp - The current display type.
 *  
 *
 * @return {JSX.Element} The JSX element representing the User Video View component
 */

const UserVideoView = () => {
  const dispatch = useDispatch()
  const cmslink = useSelector((state: any) => state.user.cmslink)
  const meuser = useSelector((state: any) => state.user.meuser)
  //const signprozess = useSelector((state: any) => state.user.signprozess)
  const showdoc = useSelector((state: any) => state.user.showmeetingdocs)
  const showsigndoc = useSelector((state: any) => state.user.showsignmeetingdocs)
  const showsigndocstapel = useSelector((state: any) => state.user.showsignmeetingdocsstapel)
  const displaywidth = useSelector((state: any) => state.user.displaywidth)

  const temppdfurl = useSelector((state: any) => state.user.temppdfurl)

  //console.log("temppdfurl:",temppdfurl)


  // Build the language code for the join link
  let intoptions = intl.getInitOptions()

  let languagcode
  if (intoptions.currentLocale === "de_DE"){
    languagcode = "de-DE"
  }
  if (intoptions.currentLocale === "en_US"){
    languagcode = "en-US"
  }

  // Build the Dispaly Name for the join link
  let viewusername = meuser.firstName + " " + meuser.lastName
  let addtourl ="&name="+viewusername
  //let addskip = "&skipJoinOptions=true"
  let addskip = ""

  let splitjoinlink
  let joinlink
  let meetingpart
  try {
    if (cmslink !== undefined){
    // Build the full join link
     splitjoinlink = cmslink.joinLink.split('meeting/')
     meetingpart = splitjoinlink[1].split('?')
     let languagepart = languagcode+"/meeting/";
     //joinlink = splitjoinlink[0]+languagepart+splitjoinlink[1]+ addtourl + addskip 
     joinlink = splitjoinlink[0]+languagepart+meetingpart[0]+"?secret="+addtourl
	} else {
		throw new Error ("CMS Link is empty");
	}
  } catch (e) {
	   console.log(e);
  } finally {
   // Fallback to default CMS join link
    if (joinlink === undefined){
      joinlink = "https://join.uc-lab.lilenium.com/meeting/"
    }
  }  


// Prepare the Display depending on Viewtype
// Differnet between DocRead and DocSign and VideoView
let ratio:number = 16 / 9;
let gridwidth = 12

    if (showsigndoc.resourceId !== undefined && showdoc.resourceId === undefined){
      if (displaywidth === 1){
        ratio = 70 / 9;
      }
      if (displaywidth === 2){
        gridwidth = 6;
      }
    } 

    if (showdoc.resourceId !== undefined){
      if (displaywidth === 1){
        ratio = 70 / 9;
      }
      if (displaywidth === 2){
        gridwidth = 6;
      }
    }

    if (showsigndocstapel.stapelId !== undefined){
      if (displaywidth === 1){
        ratio = 70 / 9;
      }
      if (displaywidth === 2){
        gridwidth = 6;
      }
    }

    if (temppdfurl !== ""){
    ratio = 70 / 9;
    }

   

    // Check ob ein Dokument angezeigt wird; wenn nein das Fenste wieder auf 100% setzten
    if (showsigndoc.resourceId === undefined && showdoc.resourceId === undefined && showsigndocstapel.stapelId === undefined){
        if (displaywidth === 6){
          dispatch(setdisplaywidth(12))
        }
      }

return (
<> 
<Grid>
    <Grid.Col span={gridwidth}>
      <AspectRatio ratio={ratio} sx={{ maxWidth: 1920 }} mx="auto">
          <iframe
            //src="https://join.uc-lab.lilenium.com/meeting/"
            src={joinlink}
            title={"Testraum"}
            allow="camera;microphone;display-capture"
            allowFullScreen
            frameBorder= "0"
          />
      </AspectRatio>
    </Grid.Col>

      

    <Grid.Col span={gridwidth}>
      {showdoc.resourceId !== undefined &&
       <UserShowDoc resourceId={showdoc.resourceId} />
      }

      {temppdfurl !== "" && 
           <AspectRatio ratio={16 / 9} sx={{ maxWidth: 1920 }} mx="auto">
          <iframe
              src={temppdfurl}
              title={"Testraum"}
              allow="camera;microphone;display-capture"
              allowFullScreen
              frameBorder= "0"
            />
        </AspectRatio>
    }
      
      {showsigndocstapel.stapelId !== undefined && 
       <UserShowSignDocStapel stapelid={showsigndocstapel.stapelId} />
      }
    </Grid.Col>
  </Grid>
</> 
  );
}


export default UserVideoView ;
/*
{showsigndoc.resourceId !== undefined &&
       <UserShowSignDoc resourceId={showsigndoc.resourceId} />
      }

{signprozess &&
        <>
        <Grid.Col span={gridwidth}>
            <Paper shadow="xs" p="xl">
                <Center>
                  <Image
                    radius="md"
                    width={92}
                    height={101}
                    src={screensharebutton}
                  />
                <ul>
                  <li>{intl.get('USERVIDEOVIEW_DOCU1')}</li>
                  <li>{intl.get('USERVIDEOVIEW_DOCU2')}</li>
                  <li>{intl.get('USERVIDEOVIEW_DOCU3')}</li>
                </ul>
              </Center>
            </Paper>
        </Grid.Col>
      </>
      }


*/